<template>
  <v-calendar expanded :rows="spansMultipleMonths ? 2 : 1" :attributes="attrs" disabled :min-date="startDate"
    :max-date="endDate" :locale="$tolgee.getLanguage()" />
</template>

<script setup lang="ts">
import { PropType, ref, computed } from "vue";
import { Availability, BookingMode } from "@/services/bikes/types";

const { availabilities } = defineProps({
  availabilities: {
    type: Object as PropType<Availability>,
    required: true,
  },
});

const startDate = new Date(availabilities?.start_date);
const endDate = new Date(availabilities?.end_date);

const spansMultipleMonths = startDate.getMonth() !== endDate.getMonth();

// Check if this is a custom periods booking mode
const isCustomPeriods = computed(() => {
  return availabilities?.booking_mode === BookingMode.CUSTOM_PERIODS;
});

const attrs = ref<Array<{}>>([]);

// for each day, create a layer with the start and end date
if (!isCustomPeriods.value) {
  availabilities?.days.forEach((day) => {
    attrs.value.push({
      key: 'days',
      order: 1,
      highlight: {
        fillMode: 'light',
        style: {
          // transparent background
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        class: 'border-b-[5px] border-success-300 !rounded-none'
      },
      content: {
        class: '!font-normal !text-neutral-700 pb-1'
      },
      dates: [
        {
          start: new Date(day.pickup.date),
          end: new Date(new Date(day.pickup.date).setDate(new Date(day.pickup.date).getDate() + (new Date(day.pickup.date).getDay() == 5 ? 3 : 2))),
        }
      ],
    });

  });
} else {
  availabilities?.days.forEach((day) => {
    attrs.value.push({
      key: 'days',
      order: 1,
      highlight: {
        fillMode: 'light',
        style: {
          // transparent background
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        class: 'border-b-[5px] border-success-300 !rounded-none'
      },
      content: {
        class: '!font-normal !text-neutral-700 pb-1'
      },
      dates: [
        {
          start: new Date(day.pickup.date),
          end: new Date(day.dropoff.date),
        }
      ],
    });
  });
}

attrs.value.push({
  key: 'base',
  highlight: {
    class: 'border-b-[5px] border-error-300 !rounded-none',
    fillMode: 'light',
    style: {
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
  },
  content: {
    class: '!font-normal !text-neutral-700 pb-1'
  },
  dates: [
    {
      start: startDate,
      end: endDate,
    },
  ],
},)
</script>